import React, { useEffect, useState, useCallback } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { getList, URLPRIFIX, baseurl, GetRecords, UpdateRecord } from "../../functions/api";
import { contentHeader } from "../../Constancs/cssconst";
import { IoRibbon, IoNotificationsCircleOutline } from "react-icons/io5";
import { VscCalendar } from "react-icons/vsc";
import { FaRegCircleUser } from "react-icons/fa6";
import Badge from "@mui/material/Badge";
import { getFulllocal, getlocal } from "../../functions/localstorage";
import {
  registerCurrentOneSignalDevice,
  isPushSupported,
} from "../../services/oneSignalService";
import { isOneSignalReady } from "../../services/oneSignalService";
import { handleNotificationNavigation } from "../../services/notificationNavigationHelper";
// No longer needed: ListView, IoChevronForwardOutline, MdCalendarMonth, Slide, toast, ToastContainer

const Header = ({ store, setsider }) => {
  const user = getlocal("system")?.user || {};
  const [currentDate, setCurrentDate] = useState(new Date());
  const [notificationPermission, setNotificationPermission] = useState("default");

  const tableURL = "/subtask/getsubtasklist";
  const [isPopupVisible, setPopupVisible] = useState({
    notification: false,
    profile: false,
    accounts: false,
    badges: false,
  });
  const [companies, setCompanies] = useState([]);
  const [hasTasksThisMonth, setHasTasksThisMonth] = useState(false);
  const notifications = store.getsystemvalue("Notification") || [];
  const unreadNotificationCount = store.getsystemvalue("UnreadNotificationCount") || 0;

  const getDynamicTableURL = useCallback(() => {
    return user.role === 1 ? tableURL : `${tableURL}/${user.id}`;
  }, [user.id, user.role]);

  useEffect(() => {
    // Initialize OneSignal login when user is available
    if (user.id) {
      initializeNotifications();
    }

    getNotification();
    getCompanyList();
    getBadgesCount();
    fetchMonthEvents();
  }, []);

  /**
   * Initialize OneSignal for the logged-in user
   */
  const initializeNotifications = async () => {
    try {
      // Wait for OneSignal SDK to be ready (timeout after ~10s)
      const start = Date.now();
      while (!isOneSignalReady() && Date.now() - start < 10000) {
        await new Promise((r) => setTimeout(r, 250));
      }

      if (!isOneSignalReady()) {
        console.warn("[Header] OneSignal SDK not ready after timeout, skipping login");
      } else {
        const token = getlocal("system")?.token;
        await registerCurrentOneSignalDevice(user, baseurl, token);
      }
    } catch (error) {
      console.error("[Header] Error initializing notifications:", error);
    }
  };

  /**
   * Handle enabling notifications
   */
  const handleEnableNotifications = async () => {
    try {
      if (!isPushSupported()) {
        console.warn("[Header] Push notifications not supported in this browser");
        return;
      }

      const token = getlocal("system")?.token;
      const registered = await registerCurrentOneSignalDevice(user, baseurl, token);
      setNotificationPermission(registered ? "granted" : "default");
      console.log("[Header] OneSignal device registration:", registered);
    } catch (error) {
      console.error("[Header] Error enabling notifications:", error);
    }
  };

  /**
   * Handle notification click - navigate to task/item using helper
   */
  const handleNotificationClick = async (notification) => {
    try {
      if (notification?.id && !notification?.isRead) {
        await UpdateRecord(`/api/notifications/${notification.id}/read`);
        store.setsystemvalue(
          "Notification",
          notifications.map((item) =>
            item.id === notification.id ? { ...item, isRead: true } : item
          )
        );
        store.setsystemvalue(
          "UnreadNotificationCount",
          Math.max(unreadNotificationCount - 1, 0)
        );
      }

      handleNotificationNavigation(
        notification,
        (url) => {
          store.navTo(url);
          togglePopup("notification");
        },
        URLPRIFIX
      );
    } catch (error) {
      console.error("[Header] Error handling notification click:", error);
      store.navTo(`/${URLPRIFIX}/dashboard`);
    }
  };

  function getNotification() {
    getList({
      listUrl: "/api/notifications/byuserid/" + user.id,
    }).then((res) => {
      console.log("notification", res);
      store.setsystemvalue("Notification", res?.data || []);
    });

    getList({
      listUrl: "/api/notifications/unreadcount/" + user.id,
    }).then((res) => {
      store.setsystemvalue("UnreadNotificationCount", res?.data?.unreadCount || 0);
    });
  }

  function formatNotificationTime(value) {
    if (!value) return "";

    const diffMs = Date.now() - new Date(value).getTime();
    const minutes = Math.floor(diffMs / 60000);
    if (minutes < 1) return "Just now";
    if (minutes < 60) return `${minutes} min${minutes === 1 ? "" : "s"} ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;

    const days = Math.floor(hours / 24);
    if (days < 7) return `${days} day${days === 1 ? "" : "s"} ago`;

    return new Date(value).toLocaleString();
  }

  const fetchMonthEvents = useCallback(async () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth(); // 0-based (July is 6)

    try {
      const res = await getList({
        listUrl: getDynamicTableURL(),
        field: "dueDate",
        search: '',
        sort: "asc",
        count: 5000,
        store: store,
      });

      const allTasks = res?.data?.list || [];

      const hasCurrentMonthTasks = allTasks.some((task) => {
        const due = new Date(task.dueDate);
        return (
          due.getFullYear() === year &&
          due.getMonth() === month // Matches current month
        );
      });

      setHasTasksThisMonth(hasCurrentMonthTasks);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
    }
  }, [currentDate]);


  function getBadgesCount() {
    GetRecords(`/users/users/` + user.id).then(async (res) => {
      store.setsystemvalue("badgecount", res?.record?.badgecount);
      console.log("badgecount**", store.getsystemvalue("badgecount"));
    });
  }

  function getCompanyList() {
    if (user.role != 1) {
      GetRecords(`/api/v2/accountingcompany/getcompanybyuserid/` + user.id).then(
        async (res) => {
          setCompanies(res?.record?.list || []);
          store.setsystemvalue("companies", res?.record?.list || []);
          console.log("companies acc", companies);
        }
      );
    } else {
      GetRecords(`/api/v2/accountingcompany/getallcompanies`).then(
        async (res) => {
          setCompanies(res?.record?.list || []);
          store.setsystemvalue("companies", res?.record?.list || []);
          console.log("companies acc", companies);
        }
      );
    }
  }

  const togglePopup = (field) => {
    let newfield = {};
    if (field === "notification") {
      newfield = {
        notification: !isPopupVisible.notification,
        profile: false,
        accounts: false,
      };
    } else if (field === "accounts") {
      newfield = {
        notification: false,
        profile: false,
        accounts: !isPopupVisible.accounts,
      };
    } else {
      newfield = {
        notification: false,
        profile: !isPopupVisible.profile,
        accounts: false,
      };
    }
    setPopupVisible((prev) => {
      prev = newfield;
      return { ...prev };
    });
  };

  return (
    <div className="grid grid-cols-12 h-full border-b-2 border-[#979797]">
      <div className="col-span-2">
        <div
          className="flex justify-center items-center h-full px-[6%] gap-2 cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            store.navTo("/" + URLPRIFIX + "/dashboard");
          }}
        >
          <img
            src="/Assets/images/Logo.png"
            alt="Logo"
            className="max-sm:w-[92px] max-sm:h-[67px] md:w-[42px] md:h-[30px] lg:w-[60px] lg:h-[40px]"
          />
        </div>
      </div>
      <div className="col-span-8 flex justify-between">
        <div className="flex items-center h-full pl-[5%] font-semibold max-sm:text-[32px] md:text-[12px] lg:text-[20px]">
          {store.getheader().toUpperCase()}
        </div>
      </div>
      <div className="col-span-1">
        <div className="flex items-center justify-center h-full gap-8 max-sm:hidden relative">
          {/* Calendar Icon */}
          <button
            onClick={(e) => {
              e.preventDefault();
              store.navTo(`/${URLPRIFIX}/calendarpage`);
            }}
            className="text-gray-600 hover:text-blue-700 transition-colors duration-200"
            title="Go to Calendar"
          >
            <Badge
              color="primary"
              variant="dot"
              invisible={!hasTasksThisMonth}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "8px",
                  minWidth: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  right: 2,
                  top: 4,
                },
              }}
            >
              <VscCalendar className="md:w-[26px] md:h-[38px] transition-transform duration-200 hover:scale-110" />
            </Badge>
          </button>


          {/* Badge Icon */}
          <button
            className="flex items-center space-x-2 text-gray-600 hover:text-blue-700 transition-colors duration-200"
            title="View Badges"
          >
            <Badge
              max={9999}
              badgeContent={store.getsystemvalue("badgecount")}
              showZero={true}
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "green",
                  color: "white",
                  fontSize: "10px",
                  width: "20px",
                  height: "20px",
                  minWidth: "20px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  top: "8px",
                  left: "10px",
                },
              }}
            >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  store.navTo(`/${URLPRIFIX}/tasks/badgeTask/${user.id}`);

                }}
                className="text-gray-600 hover:text-blue-700 transition-colors duration-200"
                title="Notifications"
              >
                <IoRibbon className="md:w-[26px] md:h-[38px] transition-transform duration-200 hover:scale-110" />

              </button>
            </Badge>
          </button>

          {/* Notification Icon */}
          <Badge
            color="error"
            badgeContent={unreadNotificationCount}
            invisible={unreadNotificationCount === 0}
            max={99}
            // Change anchorOrigin to position it over the icon's top-left (or top-right as desired)
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              "& .MuiBadge-badge": {
                fontSize: "10px",
                minWidth: "18px",
                height: "18px",
                borderRadius: "50%",
                // Adjust these values to fine-tune the dot's position *inside* the icon
                right: 5, // Move left from default 'right'
                top: 8,   // Move down from default 'top'
              },
            }}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                togglePopup("notification");
                getNotification(); // Re-fetch notifications to update the badge when opened
                console.log("On click detected ");
              }}
              className="text-gray-600 hover:text-blue-700 transition-colors duration-200"
              title="Notifications"
            >
              <IoNotificationsCircleOutline className="md:w-[32px] md:h-[42px] transition-transform duration-200 hover:scale-110 hover:animate-pulse" />
            </button>
          </Badge>

          <div
            className={
              "absolute top-full right-6 mt-0 bg-secondary min-w-[320px] max-h-[350px] p-4 shadow-2xl rounded-2xl border border-[#a9a9ff] border-1 transition-all ease-in-out " +
              (isPopupVisible.notification
                ? " z-10 opacity-100 delay-75 translate-y-0 scale-100 duration-700"
                : " -z-10 opacity-0 -translate-y-32 translate-x-4 scale-50")
            }
          >
            <h1 className={contentHeader}>Notifications</h1>

            <button
              className={
                "absolute right-5 top-4 text-[18px] bg-primary lg:h-6 lg:w-6 h-9 w-9 flex justify-center items-center rounded-full text-secondary hover:bg-tertiary hover:bg-opacity-45" +
                (isPopupVisible.notification ? " cursor-pointer " : " cursor-default ")
              }
              onClick={() => isPopupVisible.notification && togglePopup("notification")}
            >
              &times;
            </button>

            {notifications.length > 0 ? (
              <div className="overflow-y-auto max-h-[250px]">
                {notifications.map((item, index) => (
                  <div
                    key={item.id || index}
                    onClick={() => handleNotificationClick(item)}
                    className={
                      "mb-2 p-3 pt-5 border-b border-gray-300 hover:bg-tertiary hover:bg-opacity-45 cursor-pointer transition-all duration-200 rounded-lg hover:shadow-md " +
                      (!item.isRead ? "bg-white bg-opacity-90" : "bg-transparent opacity-80")
                    }
                  >
                    <h4 className="text-sm font-bold text-blue-600 hover:text-blue-800">{item.title}</h4>
                    <p className="text-sm my-3 text-gray-700">{item.message || item.body}</p>
                    <p className="text-xs text-gray-500">
                      {formatNotificationTime(item.createdAt || item.created_at)}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-600 text-sm">You have no notifications</p>
            )}
          </div>

          {store?.state?.properties?.companies?.view && (
            <div>
              {/* Accounts (Companies) Icon */}
              <button
                onClick={(e) => {
                  e.preventDefault();
                  togglePopup("accounts");
                  getCompanyList();
                  console.log("On click detected ");
                }}
                className="text-gray-600 hover:text-blue-700 transition-colors duration-200"
                title="Accounts"
              >
                <svg
                  width="28"
                  height="38"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mt-2 transition-transform duration-200 hover:scale-110"
                >
                  <path
                    d="M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M2 8H22"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7 13H17"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7 17H17"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div
                className={`absolute top-full right-6 mt-0 bg-secondary min-w-[320px] max-h-[350px] p-4 shadow-2xl rounded-2xl border border-[#a9a9ff] border-1 transition-all ease-in-out
                ${isPopupVisible.accounts ? "z-50 opacity-100" : "opacity-0 -z-20"}`}
              >
                <div>
                  <h1 className={contentHeader}>ORGANIZATIONS</h1>
                  <button
                    className={
                      "absolute right-5 top-4 text-[18px] bg-primary lg:h-6 lg-w-6 h-9 w-9 flex justify-center items-center rounded-full text-secondary hover:bg-tertiary hover:bg-opacity-45 " +
                      (isPopupVisible.accounts ? " cursor-pointer " : " cursor-default ")
                    }
                    onClick={() => isPopupVisible.accounts && togglePopup("accounts")}
                  >
                    &times;
                  </button>

                  <ul className="mt-2">
                    {companies.length > 0 ? (
                      companies.map((company) => (
                        <li
                          key={company.id}
                          className="p-2 border-b border-gray-300 hover:bg-tertiary hover:bg-opacity-45 cursor-pointer flex items-center space-x-2 transition-colors duration-200"
                          onClick={() => {
                            let local = getFulllocal();
                            local.system.user = {
                              ...local?.system?.user,
                              company: company.id,
                            };
                            if ([1, 4].includes(user.role)) {
                              store.navTo(`/${URLPRIFIX}/${company.id}/accounts/dashboard`);
                            } else {
                              store.navTo(`/${URLPRIFIX}/${company.id}/accounts/expense`);
                            }
                          }}
                        >
                          <img
                            className="h-6 w-6 rounded-md bg-gray-200 object-cover"
                            src={
                              company.company_logo
                                ? `${baseurl}/files/preview?key=${encodeURIComponent(
                                  company.company_logo
                                )}`
                                : "/Assets/images/accounts.png"
                            }
                            alt={company.company_name}
                          />
                          <span className="text-white text-sm font-medium">
                            {company.company_name}
                          </span>
                          <svg
                            className="h-3 w-3 text-[#000042]"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
                            />
                          </svg>
                        </li>
                      ))
                    ) : (
                      <li className="text-gray-600 text-sm">No companies found</li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          )}

          {/* User Profile Icon */}
          <button
            onClick={() => togglePopup("profile")}
            className="text-gray-600 hover:text-blue-700 transition-colors duration-200"
            title="Profile"
          >
            <svg width="28"
              height="38"
              viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"
              className="transition-transform duration-200 hover:scale-110"
            >
              <circle cx="24" cy="24" r="22" stroke="currentColor" stroke-width="4" />

              <circle cx="24" cy="17" r="7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M36 41V37C36 35.1144 35.2625 33.3079 33.9497 31.9497C32.6369 30.5915 30.8295 29.8333 29 29.8333H19C17.1705 29.8333 15.3631 30.5915 14.0503 31.9497C12.7375 33.3079 12 35.1144 12 37V41" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <div
            className={
              "absolute top-full right-6 mt-0 bg-secondary min-w-[220px] max-h-[350px] p-4 shadow-2xl rounded-2xl border border-[#a9a9ff] border-1 transition-all ease-in-out " +
              (isPopupVisible.profile
                ? " z-10 opacity-100 delay-75 translate-y-0 scale-100 duration-700 translate-x-0"
                : " -z-10 opacity-0 -translate-y-24 translate-x-10 scale-50")
            }
          >
            <div>
              <h1 className={contentHeader}>{user.name?.toUpperCase()}</h1>
              <h1 className={"text-[12px]"}>profile</h1>
            </div>
            <button
              className={
                "absolute right-5 top-4 text-[18px] bg-primary lg:h-6 lg:w-6 h-9 w-9 flex justify-center items-center rounded-full text-secondary hover:bg-tertiary hover:bg-opacity-45" +
                (isPopupVisible.profile ? " cursor-pointer " : " cursor-default ")
              }
              onClick={() => isPopupVisible.profile && togglePopup("profile")}
            >
              &times;
            </button>
            <div className="overflow-y-auto max-h-[250px]">
              {store?.state?.properties?.users?.view && (
                <div
                  className={
                    "mb-2 p-1 pt-3 border-b border-gray-300 hover:bg-tertiary hover:bg-opacity-45 relative " +
                    (isPopupVisible.profile ? " cursor-pointer " : " cursor-default ")
                  }
                >
                  <h1
                    onClick={() => {
                      store.navTo("/" + URLPRIFIX + "/users/profile/" + user.id);
                      isPopupVisible.profile && togglePopup("profile");
                    }}
                  >
                    My Profile
                  </h1>
                </div>
              )}
              <div
                className={
                  "mb-2 p-1 pt-3 border-b border-gray-300 hover:bg-tertiary hover:bg-opacity-45 relative " +
                  (isPopupVisible.profile ? " cursor-pointer " : " cursor-default ")
                }
              >
                <h1
                  onClick={() => {
                    store.logout();
                  }}
                >
                  Logout
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="items-center justify-center h-full gap-6 max-sm:flex hidden">
          <div
            className="text-[38px] transition-transform duration-200 hover:scale-110"
            onClick={(e) => {
              e.preventDefault();
              setsider((prev) => {
                if (prev === "max-sm:hidden") {
                  prev = "max-sm:block";
                } else {
                  prev = "max-sm:hidden";
                }
                return prev;
              });
            }}
          >
            <GiHamburgerMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
